export const getMentorMatch = (id, successCallback) => {
  fetch(`/api/v1/mentor_matches/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const updateMentorMatch = (id, params, successCallback) => {
  fetch(`/api/v1/mentor_matches/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ mentor_match: params }),
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const addMatchedMentor = (successCallback, noMentorCallback) => {
  fetch(`/api/v1/mentor_matches/patient_partner`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (response.status === 404) {
        if (noMentorCallback) noMentorCallback();
        return null;
      }
      return response.json();
    })
    .then((data) => {
      if (data) successCallback(data);
    });
};
